export default {
  'app.pwa.offline': 'आप अभी ऑफ़लाइन हैं',
  'app.pwa.serviceworker.updated': 'नई सामग्री उपलब्ध है',
  'app.pwa.serviceworker.updated.hint':
    'वर्तमान पृष्ठ को पुनः लोड करने के लिए कृपया "रीफ़्रेश" बटन दबाएँ',
  'app.pwa.serviceworker.updated.ok': 'रीफ़्रेश',
};
